import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["innerHTML"]

import { shallowRef } from 'vue';
const sharpUnicode = '&#x266F', flatUnicode = '&#x266d'

export default /*@__PURE__*/_defineComponent({
  __name: 'AccidedPname',
  props: {
    pname: {}
  },
  setup(__props: any) {

const props = __props;
const name = shallowRef(props.pname?.[0]);
const accidUnicode = shallowRef(!props.pname?.[1] ? undefined : props.pname?.[1] == '#' ?  sharpUnicode : flatUnicode)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", null, [
    _createTextVNode(_toDisplayString(name.value), 1),
    (accidUnicode.value)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          innerHTML: accidUnicode.value
        }, null, 8, _hoisted_1))
      : _createCommentVNode("", true)
  ]))
}
}

})